/** Cuts at the last full word that fits within max (ellipsis included); never mid-word. */
export function truncateAtWord(text: string, max = 155): string {
  const clean = text.replace(/\s+/g, " ").trim();
  if (clean.length <= max) return clean;
  const cut = clean.slice(0, max - 1);
  const i = cut.lastIndexOf(" ");
  return `${(i > 0 ? cut.slice(0, i) : cut).replace(/[\s,;:.\-]+$/, "")}…`;
}
